import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Stack, Typography } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useGetOrganizationUserQuery } from '../features/api/rest/apiOrganizationsSlice';
import { useGetProfileQuery } from '../features/api/rest/apiProfileSlice';
import UserCard from './UserCard';
import Spinner from './Spinner';
import Error from './Error';

function UserOrganization() {
  const { opk } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { currentData: users, error: orgError, isFetching: isOrgFetching, isLoading: isOrgLoading, isError: isOrgError } = useGetOrganizationUserQuery(opk, { refetchOnMountOrArgChange: true });
  const { currentData: profile, isFetching: isProfileFetching, isLoading: isProfileLoading, isError: isProfileError } = useGetProfileQuery();

  const adduser = () => {
    navigate(`/profile/organizations/${opk}/users-add`);
  };

  const permission = useCallback(() => {
    if ((users && users.some((user) => user.is_admin && profile.id === user.user)) || profile.is_staff) return true;
    return false;
  }, [users, profile]);

  const adminCount = useCallback(() => users.reduce((acc, currUser) => acc + (currUser.user_details.is_active && currUser.is_admin ? 1 : 0), 0), [users]);

  if (isOrgFetching || isProfileFetching || isOrgLoading || isProfileLoading) return <Spinner />;

  if (isOrgError && orgError.status === 403) return <Typography>{t('organizations.user.unauthorized')}</Typography>;

  if (isProfileError || isOrgError) return <Error />;

  return (
    <>
      {permission() && (
        <Button sx={{ mt: 2 }} startIcon={<AddIcon />} variant="contained" color="primary" onClick={adduser}>
          {t('organizations.user.add')}
        </Button>
      )}
      <Stack direction="row" spacing={2} mt={3} useFlexGap flexWrap="wrap">
        {users?.map(
          (user) => user.user_details.is_active && <UserCard username={user.user_details.username} hasPermission={permission()} adminCount={adminCount()} isadmin={user.is_admin} isowner={user.is_owner} id={user.id} key={user.id} duser={user.user} />
        )}
      </Stack>
    </>
  );
}

export default UserOrganization;
